import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import { withTUXIcon } from './withTUXIcon.js';
import * as React from 'react';

function IconLargeMissedEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor"
  }, props, {
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    className: props.className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.07 13.39a1.53 1.53 0 003.06 0v-3.36h6.5v29.94c0 14.03-4.23 16.23-8.8 18.3H12.36c3.2-2.67 5.84-7.52 5.84-18.3V10.03h6.76v3.36a1.53 1.53 0 003.05 0v-3.36h8v3.36a1.53 1.53 0 003.06 0v-3.36h8v3.36zM28.01 6.97h8V2.56a1.53 1.53 0 113.06 0v4.41h8V2.56a1.53 1.53 0 113.06 0v4.41h8.03c.84 0 1.53.69 1.53 1.53v31.47c0 16.3-6.05 19.03-10.9 21.22-.2.1-.42.14-.64.14H6.67a1.53 1.53 0 01-.63-2.92c4.69-2.11 9.11-4.11 9.11-18.44V8.5c0-.84.68-1.53 1.53-1.53h8.28V2.56a1.53 1.53 0 113.05 0v4.41zm38.1 64H24.86c-.84 0-1.53-.68-1.53-1.53v-4.42a1.53 1.53 0 113.06 0v2.9h38.2V8.5a1.53 1.53 0 113.06 0v60.94c0 .85-.68 1.53-1.52 1.53zm-33.77-30.1a1.53 1.53 0 01-1.08-2.6l4.12-4.13L31.26 30a1.53 1.53 0 012.16-2.15l4.12 4.12 4.13-4.12A1.53 1.53 0 0143.82 30l-4.12 4.13 4.12 4.12a1.53 1.53 0 01-2.15 2.16l-4.13-4.12-4.12 4.12c-.3.3-.69.45-1.08.45z"
  }));
}
var TUXIconLargeMissedEvent = withTUXIcon(IconLargeMissedEvent);

export default IconLargeMissedEvent;
export { TUXIconLargeMissedEvent };
